import React from 'react';
import { Container } from '@mui/material';
import AppLayout from './AppLayout';

type ContainedAppLayoutProps = {
  children: React.ReactNode;
};

export default function ContainedAppLayout({ children }: ContainedAppLayoutProps) {
  return (
    <AppLayout>
      <Container maxWidth={false} sx={{ my: 2 }} disableGutters>
        {children}
      </Container>
    </AppLayout>
  );
}
